import { parseString } from 'xml2js';
import { rPayBenificiaryList, rPayDeleteBenificiary, rPayRegisterBenificiary, rPayRegisterSender, rPaySenderKyc, rPayVerifyBenificiary, rPayVerifySender, rPayVerifyTxnOtp } from '../../utils/api';
import { isEmpty, isValidMobileNumber } from '../../utils/common';

export const checkSenderRegister = async (
	mobileNumber,
	position,
	setMessage,
	setLoding,
	setBeneficiaryDetails,
	setControls,
	controls,
	setAlert,
	setSelectType,
	setReferenceKey,
	setIsOTPRequired,
	setWadh,
	setTimeover,
	setOtp,
	setSenderData,
	gebeneficiaryList
) => {
	if (!isEmpty(mobileNumber)) {
		if (!isValidMobileNumber(mobileNumber)) {
			setMessage({ type: 'error', msg: 'Please enter valid mobile', place: 'form' });
			return false;
		}
		setLoding(true);
		const param = {
			senderMobile: mobileNumber,
			lattitude: position?.latitude,
			longitude: position?.longitude,
		};
		const response = await rPayVerifySender(param);
		console.log('SENDER_EKYC_REQUIRED', response);

		if (response?.success) {
			setReferenceKey(response?.data?.referenceID);
			setWadh(response?.data?.wadh);
			setIsOTPRequired(response?.data?.data?.isOTPRequired);
			setTimeover(false);
			setOtp('');

			if (response?.data?.msg === 'SENDER_EKYC_REQUIRED') {
				setLoding(false);
				setControls({ ...controls, mobileNumber: mobileNumber });
				setAlert({ type: 'success', msg: 'Please complete sender kyc' });
				setSelectType('KYC_SCREEN');
			} else if (response?.data?.msg === 'SENDER_REGISTERATION_REQUIRED') {
				setAlert({ type: 'success', msg: 'Please complete sender registration' });
				setSelectType('ADD_NEW_PAYEE');
				setControls({ ...controls, mobileNumber: mobileNumber });
				setLoding(false);
			} else {
				setSenderData(response?.data?.data);
				gebeneficiaryList()
			//	getListing(param, setBeneficiaryDetails, setActiveMobilePop, setSelectType, setAlert, setLoding, setIsOTPRequired, setShowList, setReferenceKey);
			}
		} else {
			setBeneficiaryDetails(null);

			if (response?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: response?.errorCodeList[0] });
			} else {
				setAlert({ type: 'error', msg: response?.msg });
			}
		}

		setLoding(false);
	} else {
		setMessage({ type: 'error', msg: 'Please enter valid mobile number', place: 'form' });
		setLoding(false);
	}
};



export const registerSender_ = (params, setLoding, setSelectType, setAlert, gebeneficiaryList) => {
	rPayRegisterSender(params).then((response) => {
		setLoding(false);
		if (response?.success) {
			setSelectType('SEND_MONEY');
			const payload = {
				senderMobile: params.senderMobile,
				lattitude: params.lattitude,
				longitude: params.longitude,
			};
			setAlert({ type: 'success', msg: 'Sender registered successfully' });
			gebeneficiaryList()
			//getListing(payload, setBeneficiaryDetails, setActiveMobilePop, setSelectType, setAlert, setLoding, setIsOTPRequired, setShowList, setReferenceKey);
		} else {
			if (response?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: response?.errorCodeList[0] });
			} else {
				setAlert({ type: 'error', msg: response?.msg });
			}
		}
	});
};

export const getListing = (param, setBeneficiaryDetails, setActiveMobilePop, setSelectType, setAlert, setLoding, setIsOTPRequired, setShowList, setReferenceKey,loding) => {
	setLoding(true);
	console.log("loding",loding)

   rPayBenificiaryList(param).then((response) => {
	   if (response?.success) {
		   setShowList(true);
		   setReferenceKey(response?.data?.referenceID);
		   setIsOTPRequired(false);
		   setBeneficiaryDetails(response?.data?.data || []);
		   setActiveMobilePop(true);
		   setSelectType('SEND_MONEY');
		   console.log("setLoding",setLoding)
		   setTimeout(() => {
			   setLoding(false);
		   }, 1000);
	   } else {
		   setBeneficiaryDetails([]);
		   setLoding(false);

		   if (response?.errorCodeList.length > 0) {
			   setAlert({ type: 'error', msg: response?.errorCodeList[0] });
		   } else {
			   setAlert({ type: 'error', msg: response?.msg });
		   }
	   }
   });
};

let testMantraPort = 1;
export function Capture(setFingerprintLoader, setLoding, setAlert, deviceType, payload, setSelectType, wadh, setReferenceKey, setIsOTPRequired) {
	setFingerprintLoader(true);
	var url = '';
	var PIDOPTS = '';
	let biometricData = null;
	setLoding(true);
	if (deviceType === 'Morpho') {
		PIDOPTS = `<PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="${wadh}" posh=""/></PidOptions>`;

		if (testMantraPort === 1) {
			url = 'http://127.0.0.1:11100/capture';
		} else {
			url = 'https://127.0.0.1:11100/capture';
		}
		// url = 'http://127.0.0.1:11100/capture';
	} else if (deviceType === 'Mantra') {
		PIDOPTS = `<PidOptions ver="1.0"><Opts fCount="1" fType="2" iCount="0" pCount="0" pgCount="1" format="0"   pidVer="2.0" timeout="10000"  wadh="${wadh}"  posh="" env="P" /> <CustOpts><Param name="mantrakey" value="" /></CustOpts></PidOptions>`;

		const preUrl = localStorage.getItem('MantraRdUrll');
		if (preUrl) {
			url = preUrl;
		} else {
			if (testMantraPort === 1) {
				url = `https://127.0.0.1:11100/rd/capture`;
			} else if (testMantraPort === 2) {
				url = 'https://127.0.0.1:11101/rd/capture';
			} else if (testMantraPort === 3) {
				url = 'https://127.0.0.1:8005/rd/capture';
			}
		}
	} else if (deviceType === 'Tatvik') {
		url = 'https://127.0.0.1:11100/rd/capture';
	}

	var xhr;

	xhr = new XMLHttpRequest();
	xhr.open('CAPTURE', url, true);
	xhr.setRequestHeader('Content-Type', 'text/xml');
	xhr.setRequestHeader('Accept', 'text/xml');

	xhr.onreadystatechange = async function () {
		setFingerprintLoader(false);
		if (xhr.readyState === 4) {
			var status = xhr.status;

			if (status === 200) {
				var test1 = xhr.responseText;
				var test2 = test1.search('errCode');
				var test6 = getPosition(test1, '"', 2);
				var test4 = test2 + 9;
				var test5 = test1.slice(test4, test6);

				convertXmlToJs(xhr.responseText).then((result) => {
					const error = result?.PidData?.Resp[0].$;

					if (Number(error.errCode) != 0) {
						setLoding(false);
						setAlert({ type: 'error', msg: error.errInfo });
						if (deviceType === 'Mantra') {
							if (testMantraPort === 1) {
								const url = `https://127.0.0.1:11100/rd/capture`;
								localStorage.setItem('MantraRdUrl', url);
							} else if (testMantraPort === 2) {
								const url = 'https://127.0.0.1:11101/rd/capture';
								localStorage.setItem('MantraRdUrl', url);
							} else if (testMantraPort === 3) {
								const url = 'https://127.0.0.1:8005/rd/capture';
								localStorage.setItem('MantraRdUrl', url);
							}
						}

						return;
					}

					setLoding(false);
					setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully' });

					payload.piddata = xhr.responseText;
					// console.log(JSON.stringify(xhr.responseText))
					verifyBioData(payload, setLoding, setSelectType, setAlert, setReferenceKey, setIsOTPRequired);
				});
			} else {
				setLoding(false);
			}
		}
	};

	xhr.onerror = function () {
		setFingerprintLoader(false);
		if (deviceType === 'Mantra') {
			setLoding(false);
			if (testMantraPort < 3) {
				testMantraPort = testMantraPort + 1;
				Capture(setFingerprintLoader, setLoding, setAlert, deviceType, payload, setSelectType, wadh, setReferenceKey, setIsOTPRequired);
			}
		}
		if (deviceType === 'Morpho') {
			setLoding(false);
			if (testMantraPort < 2) {
				testMantraPort = testMantraPort + 1;
				Capture(setFingerprintLoader, setLoding, setAlert, deviceType, payload, setSelectType, wadh, setReferenceKey, setIsOTPRequired);
			}
		}
	};
	xhr.send(PIDOPTS);
}

function convertXmlToJs(xmlData) {
	return new Promise((resolve, reject) => {
		parseString(xmlData, (err, result) => {
			if (err) {
				reject(err);
			} else {
				resolve(result);
			}
		});
	});
}

function getPosition(string, subString, index) {
	return string.split(subString, index).join(subString).length;
}

const verifyBioData = (param, setLoding, setSelectType, setAlert, setReferenceKey, setIsOTPRequired) => {
	setLoding(true);
	rPaySenderKyc(param).then((response) => {
		setLoding(false);
		if (response?.success) {
			if (response.data.msg === 'SENDER_REGISTERATION_REQUIRED') {
				setReferenceKey(response?.data?.referenceID);
				setIsOTPRequired(response?.data?.data?.isOTPRequired);
				setAlert({ type: 'success', msg: 'Biometric kyc has been completed.Please complete sender registration' });
				setSelectType('ADD_NEW_PAYEE');
			} else {
				setSelectType('SEND_MONEY');
			}
		} else {
			if (response?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: response?.errorCodeList[0] });
			} else {
				setAlert({ type: 'error', msg: response?.msg });
			}
		}
	});
};

export const verifyTxnOtp = (payload, setAlert, setLoding, setRefresh, refresh, setModal) => {
	setLoding(true);
	rPayVerifyTxnOtp(payload).then((response) => {
		setLoding(false);
		if (response?.success) {
			if(response?.data?.txnMessage === "SUCCESS"){
				setAlert({ type: 'success', msg: "Transaction Successful" });
			}else{
				setAlert({ type: 'error', msg: response?.data?.txnMessage });
			}
		
			setModal({ name: 'TRANSACTION_SUCCESS_MODAL', modalData: response?.data });
			setRefresh(!refresh);
		} else {
			setModal({ name: '', modalData: null });
			if (response?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: response?.errorCodeList[0] });
			} else {
				setAlert({ type: 'error', msg: response?.msg });
			}
		}
	});
};




